/*
 * @Description:
 */
import { getToken } from '@/utils/cookies'
import { UserModel } from '@/model/userModel'

export interface UserState{
    token: string
    info: UserModel | null
    roles: string[]
    menu: string[]
    permission: string[]
}

export const state: UserState = {
  token: getToken() || '',
  info: null,
  roles: [],
  menu: [],
  permission: []
}
